module.exports.home = {
  footer: {
    connect: "Let's connect",
    toHelpYou: 'We are here to help you',
    business: 'Business',
    purchasePolicy: 'Purchase policy',
    noticePrivacy: 'Notice of privacy',
    allRightsReserved: 'All rights reserved',
  },
  footer2: {
    politicas:'Privacy policies',
    transparencia:'Transparency',
    cuenta:'Public account',
    apartado:'Integrity section',
    directorio:'Directory',
    programa:'Programs and calls',
    ubication:'Location:',
    mail:'Email:',
    tel:'Phone:',
    oficinaH:'Office Hours:',
    oficinaH2:'Monday to Friday 9:00 am-6:00 pm',
    CinemaH:'Cinema Hours:',
    CinemaH2:'Monday to Sunday',
    SiteInt:'Sites of Interest',
    Gob:'Government of Yucatan',
    NKukulkan:'Nights of Kukulkan',
  },
  lostMyPassMessage: {
    part1: "Write or copy/paste the code that was sent to your email,",
    part2: "add '0' to the left if less than 6 numbers."
  }
}